import { useContext } from "react";
import { LocaleContext } from "../../contexts/locale/locale";
import { Button } from "../button/button";
import { NavigationItem } from "./navigation-item/navigation-item";
import classes from "./navigation.module.css";

export const Navigation = () => {
	const { texts } = useContext(LocaleContext);

	return (
		<header className={classes.navigation}>
			<a href="/">
				<img
					className={classes.logo}
					src="/logo.svg"
					alt={texts.general.name}
				/>
			</a>
			<NavigationItem label={texts.navigation.profile} url="/#profile" />
			<NavigationItem label={texts.navigation.objects} url="/#objects" />
			<NavigationItem label={texts.navigation.company} url="/#company" />
			<Button
				label={texts.navigation.contact}
				url={`${window.location.pathname}#contact`}
				variant="secondary"
			/>
		</header>
	);
};
